// Live mic waveform: symmetric rounded bars driven by a Web Audio AnalyserNode.
// Falls back to gentle idle bars when there's no analyser (e.g. record-without-audio) or
// when reduced motion is preferred.

export function mountWaveform(canvas, analyser, accent) {
  const ctx = canvas.getContext('2d');
  const reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const bins = analyser ? new Uint8Array(analyser.frequencyBinCount) : null;
  const BARS = 28;
  let raf = 0;
  let paused = false;
  let phase = 0;

  function resize() {
    const dpr = window.devicePixelRatio || 1;
    const w = canvas.clientWidth || 288;
    const h = canvas.clientHeight || 56;
    canvas.width = w * dpr;
    canvas.height = h * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  resize();

  function frame() {
    raf = requestAnimationFrame(frame);
    const w = canvas.clientWidth || 288;
    const h = canvas.clientHeight || 56;
    ctx.clearRect(0, 0, w, h);

    const gap = 3;
    const bw = (w - gap * (BARS - 1)) / BARS;
    phase += 0.06;

    for (let i = 0; i < BARS; i++) {
      let level;
      if (paused || reduced) {
        level = 0.08;
      } else if (bins) {
        analyser.getByteFrequencyData(bins);
        level = bins[Math.floor((i * bins.length) / BARS)] / 255;
      } else {
        level = 0.12 + 0.08 * (Math.sin(phase + i * 0.5) + 1) / 2; // idle shimmer
      }
      const bh = Math.max(3, level * (h - 6));
      const x = i * (bw + gap);
      const y = (h - bh) / 2; // centered -> symmetric
      ctx.fillStyle = paused ? 'rgba(150,150,164,0.55)' : accent;
      roundRect(ctx, x, y, bw, bh, Math.min(bw / 2, bh / 2));
      ctx.fill();
    }
  }
  frame();

  return {
    setPaused(p) { paused = p; },
    stop() { cancelAnimationFrame(raf); },
  };
}

function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}
